import {A360Lookup} from 'Quoting/models/DTOs/QuoteForm';

type Lookup = Array<Pick<A360Lookup, 'code' | 'displayValue' | 'orderNo'>>;

export const declineByCompanyReasons: Lookup = [
  {code: 'ATM', displayValue: 'Account not target market', orderNo: 0},
  {code: 'COC', displayValue: 'Change in Exposure - COC', orderNo: 1},
  {code: 'ES', displayValue: 'Does not fit EQ/Brush strategy', orderNo: 2},
  {code: 'UAME', displayValue: 'Unacceptable Auto MVR/Clue experience', orderNo: 3},
  {code: 'UCE', displayValue: 'Unacceptable Coastal exposure', orderNo: 4},
  {code: 'UCLE', displayValue: 'Unacceptable CAT loss experience', orderNo: 5},
  {code: 'UCPLE', displayValue: 'Unacceptable Collections PC loss experience', orderNo: 6},
  {code: 'UFE', displayValue: 'Unacceptable Florida exposure', orderNo: 7},
  {code: 'UHLE', displayValue: 'Unacceptable Home loss experience', orderNo: 8},
  {code: 'UIP', displayValue: 'Unacceptable Insured Profile', orderNo: 9},
  {code: 'ULLE', displayValue: 'Unacceptable Liability loss experience', orderNo: 10},
  {code: 'UWLE', displayValue: 'Unacceptable water loss experience', orderNo: 11},
  {code: 'other', displayValue: 'Other', orderNo: 12},
];

export const declineByCustomerReasons: Lookup = [
  {code: 'cnotc', displayValue: 'Coverages not competitive', orderNo: 0},
  {code: 'price', displayValue: 'Price too high', orderNo: 1},
  {code: 'other', displayValue: 'Other', orderNo: 2},
];
